<template>
    <div>
        <!-- 黑名单管理弹窗 -->
		<el-dialog title="黑名单管理" @close="closeBlackVisible" :visible.sync="visible" :close-on-click-modal="false" width="50%">
			<div class="blackListContent">
				<p class="f-s-12 m-b-5 c-999">说明：此黑名单仅在质控领取任务后生效（在项目推送中屏蔽黑名单译员无法领取任务）；</p>
				<p class="f-s-12 t-i-2 c-999 m-b-15">如项目中仍出现黑名单译员，为正常现象。拉黑一次生效30天，拉黑3次自动永久拉黑；</p>
				<div class="d-f justify-s align-c m-b-15">
					<el-input class="w-240 m-r-10" placeholder="请输入译员昵称进行搜索" v-model="searchBlackKey"></el-input>
					<el-button type="primary" plain icon="el-icon-search" @click="getBlackList">搜索</el-button>
					<el-button type="info" plain icon="el-icon-refresh-left" @click="resetSearch">重置</el-button>
				</div>
				<div class="d-f justify-b f-s-12 c-333 m-b-10">
					<span>拉黑译员列表</span>
					<span>有效黑名单人数：共<em class="c-409EFF f-w-600">{{page1.maxLimit}}</em>人</span>
				</div>
				<el-table :data="blackList" border :size="small" max-height="300px">
					<el-table-column prop="trName" label="译员昵称" align="center">
						<template slot-scope="scope">
							<span style="white-space: pre;">{{ scope.row.trName }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="statusDesc" label="拉黑状态" align="center" width="80px"></el-table-column>
					<el-table-column prop="disabledCount" label="拉黑次数" align="center" width="80px"></el-table-column>
					<el-table-column prop="unblockDate" label="解封日期" align="center" width="90px"></el-table-column>
					<el-table-column prop="" label="操作" align="center" width="150px">
						<template slot-scope="scope">
							<el-button v-show="scope.row.status!=1" type="text" size="mini" class="c-danger" @click="shield(scope.row, 1)">拉黑</el-button>
							<el-button v-show="scope.row.status == 1" type="text" size="mini" @click="shield(scope.row, 2)">取消拉黑</el-button>
							<el-button v-if="scope.row.showLog" type="text" size="mini" @click="openLogList(scope.row)">操作日志</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="t-c" v-if="page1.total > 10">
					<el-pagination
						class="p-t-10"
						@current-change="handleCurrentChange"
						:current-page="page1.pageNum"
						:page-size="page1.pageSize"
						layout="total, prev, pager, next, jumper"
						:total="page1.total">
					</el-pagination>
				</div>
			</div>
		</el-dialog>

		<!-- 操作日志 -->
		<el-dialog :title="`操作日志--${tranlaterName}`" :visible.sync="actLogVisible"  :close-on-click-modal="false" width="40%">
			<el-table :data="logList" border :size="small">
				<el-table-column prop="operateTime" label="操作时间" align="center"></el-table-column>
				<el-table-column prop="remark" label="操作事项" align="center"></el-table-column>
			</el-table>
			<div class="t-c" v-if="page2.total > 10">
				<el-pagination
					class="p-t-10"
					@current-change="handleCurrentChange"
					:current-page="page2.pageNum"
					:page-size="page2.pageSize"
					layout="total, prev, pager, next, jumper"
					:total="page2.total">
				</el-pagination>
			</div>
		</el-dialog>
    </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import { qcDisableLogPage, qcDisableTrPage, qcDisableTr } from '@/api/qc/qcflow'
import {statistics} from '@/api/dot/flow'

export default {
    props: ['blackListVisible', 'staParams'],
    data() {
        return {
            visible: false, //黑名单管理弹窗显示状态
			blackList: [],//黑名单列表
			searchBlackKey: '',//黑名单搜索关键字
			page1: {//黑名单列表分页
				pageSize: 10,
				pageNum: 1,
				total: 0,
				maxLimit: 0,
			},
			actLogVisible: false,//操作日志弹窗显示状态
			logList: [], //操作日志列表
			page2: {//黑名单操作日志分页
				pageSize: 10,
				pageNum: 1,
				total: 0
			},
			tranlaterName: '', //拉黑译员昵称
        }
    },
    computed: {
		...mapGetters(['permissions']),
		...mapState({
		    userInfo: state => state.user.userInfo
		}),
	},
    methods: {
        init() {
            this.visible = this.blackListVisible;
            this.getBlackList();
        },

		// 关闭黑名单管理弹窗
		closeBlackVisible() {
			this.searchBlackKey = '';
			this.visible  = false;
		},

		// 获取黑名单列表
		getBlackList() {
			qcDisableTrPage({
				current: this.page1.pageNum,
				size: this.page1.pageSize,
				staffId: this.userInfo.staffId,
				trName: this.searchBlackKey,
			}).then(res=>{
				this.blackList = res.data.data.records;
				this.page1.total = res.data.data.total;
				this.page1.maxLimit = res.data.data.maxLimit;
			}).catch((error)=>{
				this.blackList = [];
			})
			statistics(Object.assign({
				event_name: '黑名单管理',
				event_type: 'click',
				class_name: 'qcDisableTrPage',
				class_url: '/dotadmin/dotadmin/qcflow/qcDisableTrPage',
				event_params: '{current: this.page1.pageNum, size: this.page1.pageSize, staffId: this.userInfo.staffId, trName: this.searchBlackKey}'
			}, this.staParams))
		},

		// 黑名单分页
		handleCurrentChange(val) {
            this.page1.pageNum = val;
            this.getBlackList();
        },

		// 重置
		resetSearch() {
			this.searchBlackKey = '';
			this.getBlackList();
		},

		// 拉黑/取消拉黑
		shield(row, status) {
			this.$confirm(`确定${status==1?'拉黑':'取消拉黑'}译员“${row.trName}”？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				qcDisableTr({
					staffId: this.userInfo.staffId,
					status: status,
					trId: row.trId
				}).then(res=>{
					this.$message.success('操作成功');
					this.getBlackList();
				})
			})
			
		},

		// 打开操作日志列表
		openLogList(row) {
			this.tranlaterName = row.trName;
			this.getLogList(row);
			this.actLogVisible = true;
		},

		// 获取操作日志列表
		getLogList(row) {
			qcDisableLogPage({
				current: this.page2.pageNum,
				size: this.page2.pageSize,
				staffId: this.userInfo.staffId,
				trId: row.trId
			}).then(res=>{
				this.logList = res.data.data.records;
				this.page2.total = res.data.data.total;
			})
		},
    },
}
</script>
